import { SearchOutlined } from '@ant-design/icons';
import { useFormContext, withForm } from '@oscar/form';
import { ActionButtons } from '@oscar/table';
import { Button, Col, Form, Input, Row, Select } from '@oscar/theme';
import { useDeepCompareEffect } from '@oscar/utils';
import { APIS } from 'common/constants/endpoints';
import { debounce } from 'lodash';
import React from 'react';
import AddEditPopup from './AddEditPopup';

const { useForm } = Form;
const { Option } = Select;

export type SearchToolProps = {
  actionTable?: any;
  metadata?: any;
};

const SearchTool: React.FC<SearchToolProps> = ({ actionTable, metadata }) => {
  const [formContext] = useFormContext();
  const [form] = useForm();
  const [showAddPopup, setShowAddPopup] = React.useState(false);
  const listCompany = formContext.selectors?.getDataByKey('getCompany') || {};

  useDeepCompareEffect(() => {
    form.setFieldsValue(metadata?.filters);
  }, [metadata]);

  const handleSearchEnter = debounce((value: any) => {
    actionTable?.methods?.fetchData({
      filters: { keyWord: value },
    });
  }, 500);

  const handleConpanyChange = (value: any) => {
    if (value.length > 0) {
      actionTable?.methods?.fetchData({
        filters: { companyId: value },
      });
    } else {
      actionTable?.methods?.fetchData({
        filters: { companyId: null },
      });
    }
  };

  return (
    <>
      <Form layout="vertical" form={form}>
        <div className="group-fillter-request">
          <Row key="filter-request" gutter={16}>
            <Col span={14}>
              <Form.Item
                name="keyWord"
                label="Search Name / Email"
                className="title-filter-request"
                getValueFromEvent={(e: any) => {
                  handleSearchEnter(e.target.value);
                  return e.target.value;
                }}
              >
                <Input
                  size="large"
                  placeholder="Search"
                  prefix={<SearchOutlined />}
                  maxLength={100}
                />
              </Form.Item>
            </Col>

            <Col span={8}>
              <Form.Item
                name="company"
                label="Company"
                className="title-filter-request"
                getValueFromEvent={(value: any) => {
                  handleConpanyChange(value);
                  return value;
                }}
              >
                <Select
                  mode="multiple"
                  size="large"
                  allowClear
                  placeholder="Select all"
                  filterOption={(input: any, option: any) => {
                    return (
                      option.props.children
                        .toLowerCase()
                        .indexOf(input.toLowerCase()) >= 0
                    );
                  }}
                >
                  {listCompany?.company?.map((com: any, key: any) => (
                    <Option value={com.id} key={`${key}${com.id}`}>
                      {com.label}
                    </Option>
                  ))}
                </Select>
              </Form.Item>
            </Col>

            <Col span={2} className="padding-btn-export">
              <Button
                type="primary"
                size="large"
                onClick={() => setShowAddPopup(true)}
              >
                Add User
              </Button>
            </Col>
          </Row>
        </div>
      </Form>
      {showAddPopup && (
        <AddEditPopup
          title="Add User"
          isVisible={showAddPopup}
          labelConfirm="Submit"
          handleCancel={() => setShowAddPopup(false)}
          typePopup="add"
          actionTable={actionTable}
        />
      )}
    </>
  );
};

export default withForm<SearchToolProps>({
  name: 'company',
  preload: [
    {
      name: 'getCompany',
      url: APIS.META_DATA_USER_COMPANY,
      method: 'GET',
    },
  ],
})(SearchTool);
